import { render, staticRenderFns } from "./idCardUpload.vue?vue&type=template&id=080e035a&scoped=true"
import script from "./idCardUpload.vue?vue&type=script&lang=js"
export * from "./idCardUpload.vue?vue&type=script&lang=js"
import style0 from "./idCardUpload.vue?vue&type=style&index=0&id=080e035a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e035a",
  null
  
)

export default component.exports